import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'appId'];
const missingKeys = requiredKeys.filter((key) => !firebaseConfig[key]);

export const quoteOwnerUserId = process.env.REACT_APP_QUOTE_OWNER_USER_ID;
export const firebaseReady = missingKeys.length === 0 && Boolean(quoteOwnerUserId);
export const firebaseSetupMessage = firebaseReady
  ? ''
  : `Missing Firebase quote app environment values: ${[
    ...missingKeys,
    !quoteOwnerUserId ? 'REACT_APP_QUOTE_OWNER_USER_ID' : '',
  ].filter(Boolean).join(', ')}.`;

const app = firebaseReady ? initializeApp(firebaseConfig) : null;

export const db = app ? getFirestore(app) : null;
